import gql from 'graphql-tag';

export const createQrCode = gql`
  mutation CreateQrCodeMutation($input: CreateQrCode!) {
    createQrCode(input: $input)
  }
`;

export const createWorkflowEntitiesExport = gql`
  mutation CreateWorkflowEntitiesExportMutation($input: CreateWorkflowEntitiesExport!) {
    createWorkflowEntitiesExport(input: $input)
  }
`;
